<script setup lang="ts">
import { onMounted, type Ref, ref } from "vue";
import { toast } from "vue-sonner";
import type {ProductVariantResponse} from "../../../responses/ProductVariantResponse.ts";
import type { PurchaseListResponse } from "../../../responses/PurchaseListResponse";
import { label } from "../../mixins/translations";
import { usePurchaseListStore } from "../../stores/purchaseList";
import PurchaseListSelectModal from "./PurchaseListSelectModal.vue";

interface Props {
    variant: ProductVariantResponse;
}

defineOptions({
    inheritAttrs: false,
});

const props = defineProps<Props>();
const purchaseListStore = usePurchaseListStore();
const showPurchaseListModal: Ref<boolean> = ref(false);
const loggedIn: Ref<boolean> = ref(false);

const addItemToPurchaseList = (purchaseListId: number | undefined = undefined) => {

    purchaseListStore.createPurchaseListItem({
        item_code: props.variant.item_code,
        purchase_list: purchaseListId,
    }).then(() => {
        toast.success(label('site.purchase_list.added_to_list'));
    });
};

const addItem = async () => {
    await purchaseListStore.loadPurchaseLists();

    if (purchaseListStore.purchaseLists.length > 1) {
        showPurchaseListModal.value = true;
        return;
    }

    addItemToPurchaseList(purchaseListStore.purchaseLists[0]?.id);
};

const selectPurchaseList = (list: PurchaseListResponse) => {
    addItemToPurchaseList(list.id);
};

onMounted(() => {
    loggedIn.value = window.logged_in ?? false;
});
</script>

<template>
    <div class="contents">
        <button v-if="loggedIn" type="button" v-bind="$attrs" aria-label="Bestellijst" @click="addItem()">
            <slot />
        </button>

        <PurchaseListSelectModal
            v-model:open="showPurchaseListModal"
            :lists="purchaseListStore.purchaseLists"
            @select="selectPurchaseList"
        />
    </div>
</template>
